import React, { Fragment } from 'react';
import Grid from '../../../../components/Grid';
import { Subscription, ProductDescription, ProductLogo, ProductSection, SUBSCRIPTION_TYPE } from './ActivationContent';
var PingdomPageSpeed = "https://cdn.solarwinds.cloud/cloud-ui/assets/pingdom-pagespeed-29fc50e8b96048a628bacad8127bb5f0.svg";
var PingdomUptime = "https://cdn.solarwinds.cloud/cloud-ui/assets/pingdom-uptime-21dcfe802176eaffdd22d11b155e1ca0.svg";
var PingdomVisitorInsights = "https://cdn.solarwinds.cloud/cloud-ui/assets/pingdom-visitorinsights-0410a670e3b43242a7b926d4ce631356.svg";
var PingdomLogo = "https://cdn.solarwinds.cloud/cloud-ui/assets/pingdom-logo-2c9d0f1310c3a5014ba111f8c69bd574.svg";
export var PingdomContent = function PingdomContent(_ref) {
  var productStatus = _ref.productStatus;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ProductLogo, {
    logo: PingdomLogo
  }), /*#__PURE__*/React.createElement(ProductDescription, {
    title: "Deliver a higher quality web experience",
    content: "Pingdom offers you an outside perspective on the availability, functionality, and performance of your websites and web applications."
  }), /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(ProductSection, {
    image: PingdomPageSpeed,
    title: "Speed and Functionality",
    content: "Measure your website\u2019s page speed over time and make sure important transactions work as expected."
  }), /*#__PURE__*/React.createElement(ProductSection, {
    image: PingdomUptime,
    title: "Real-User Monitoring",
    content: "Learn how your visitors are experiencing your website with Visitor Insights and know what bottlenecks to improve."
  }), /*#__PURE__*/React.createElement(ProductSection, {
    image: PingdomVisitorInsights,
    title: "Availability",
    content: "With Pingdom Uptime, you will be the first to know when your website goes down - not your customers."
  })), /*#__PURE__*/React.createElement(Subscription, {
    productStatus: productStatus,
    type: SUBSCRIPTION_TYPE.TRIAL
  }));
};